import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getInitials = (firstName: string, lastName?: string) => {
  if (firstName && !lastName) {
    const safe = (firstName ?? '').trim();
    if (!safe) return 'WS';
    return safe
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w[0]!)
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  if (!firstName || !lastName) return '';

  const firstInitial = firstName.charAt(0).toUpperCase();
  const lastInitial = lastName.charAt(0).toUpperCase();

  return firstInitial + lastInitial;
};


export const normalize = (s: unknown) =>
  String(s ?? '')
    .trim()
    .toLowerCase();

export const stripHtml = (s: string) => {
  return (s ?? '').replace(/<[^>]*>/g, '').trim();
};

export function formatTime(dateString: string) {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    });
  } catch {
    return '—';
  }
}